import { FormControl, FormField, FormInput, FormItem, FormLabel, FormMessage, Text } from "@sentricmusic/ui";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import type { GigClaimFormValues } from "../utils/gigsClaimSchema";

function OtherPerformersSection() {
  const { t } = useTranslation(["gigs"]);
  const { control } = useFormContext<GigClaimFormValues>();

  return (
    <div>
      <Text as="subtitle">{t("gigs:other-performers-header", "Other performers")}</Text>
      <div className="flex flex-col gap-2">
        <FormField
          control={control}
          name="headlineArtist"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t("gigs:headline-artist-caps", "Headline Artist")}</FormLabel>
              <FormControl>
                <FormInput
                  placeholder={t("gigs:headline-artist-caps", "Headline Artist") ?? "Headline Artist"}
                  {...field}
                  value={field.value ?? ""}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={control}
          name="supportArtist1"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t("gigs:support-artist1", "Support Artist 1")}</FormLabel>
              <FormControl>
                <FormInput
                  placeholder={t("gigs:support-artist1", "Support Artist 1") ?? "Support Artist 1"}
                  {...field}
                  value={field.value ?? ""}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={control}
          name="supportArtist2"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t("gigs:support-artist2", "Support Artist 2")}</FormLabel>
              <FormControl>
                <FormInput
                  placeholder={t("gigs:support-artist2", "Support Artist 2") ?? "Support Artist 2"}
                  {...field}
                  value={field.value ?? ""}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={control}
          name="supportArtist3"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t("gigs:support-artist3", "Support Artist 3")}</FormLabel>
              <FormControl>
                <FormInput
                  placeholder={t("gigs:support-artist3", "Support Artist 3") ?? "Support Artist 3"}
                  {...field}
                  value={field.value ?? ""}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
}

export default OtherPerformersSection;
